// extracted by mini-css-extract-plugin
module.exports = {"title":"accordion-demo_title__2bPrw","demo":"accordion-demo_demo__2h4AZ","description":"accordion-demo_description__29Ho8","content":"accordion-demo_content__1RUQm"};